import styled from 'styled-components';
import { IonButtons, IonIcon } from '@ionic/react';

export const BackButton = styled.button`
  outline: none;
  background: transparent;
  color: #000000;
  font-size: 24px;
  padding: 0;
  margin-left: -8px;
`;

export const BookingSteps = styled.div`
  font-size: 12px;
  color: #1d201f;
  text-align: center;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-word;
`;

export const BookingTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 8px;
  width: 100%;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  color: #1d201f;
`;

export const ChevronHeaderTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const IconButtons = styled(IonButtons)`
  cursor: pointer;
`;

type HeaderIconProps = {
  iconSize: 'small' | 'medium' | 'large';
};

export const HeaderIcon = styled(IonIcon)<HeaderIconProps>`
  cursor: pointer;
  width: ${({ size }) => (size === 'small' ? '16px' : size === 'medium' ? '24px' : '32px')} !important;
  height: ${({ size }) => (size === 'small' ? '16px' : size === 'medium' ? '24px' : '32px')} !important;
`;
